
export function isOnboardingFlow() {
  return window.location.href.includes('onboarding');
}
